"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var avatar_png_1 = __importDefault(require("../static/images/avatar.png"));
var MusicLink_1 = __importDefault(require("./MusicLink"));
function Header(_a) {
    var children = _a.children;
    return (react_1.default.createElement("header", { id: "header" },
        react_1.default.createElement("div", { className: "inner" },
            react_1.default.createElement("a", { href: "/", className: "image avatar" },
                react_1.default.createElement("img", { src: avatar_png_1.default, alt: "" })),
            react_1.default.createElement("h1", null,
                "My name is",
                ' ',
                react_1.default.createElement("strong", null,
                    react_1.default.createElement(react_router_dom_1.Link, { to: "/" }, "Caroline")),
                "."),
            react_1.default.createElement("br", null),
            react_1.default.createElement("h1", null,
                "Find out ",
                react_1.default.createElement(react_router_dom_1.Link, { to: "/about" }, "about me"),
                ", what I'm",
                ' ',
                react_1.default.createElement(MusicLink_1.default.AlbumsLink, null, "listening to"),
                ", or check out my",
                ' ',
                react_1.default.createElement("a", { href: "/ctm-resume.pdf" }, "resume"),
                ".",
                ' ')),
        children));
}
exports.default = Header;
